import React, { Component } from 'react';
import $ from "jquery";
import Server from '../../functions/server';
import Loading from '../loading';
import View from './view';
import ReadCookie from '../../functions/readcookies';
import { Card, Pagination, Button } from 'semantic-ui-react'
import Paper from '@material-ui/core/Paper';

class Home extends Component {

  state = {
    data: [],
    load: false,
    pageNumber: 0,
    totalPages: 50,
    boundaryRange: 1,
    siblingRange: 1,
    showEllipsis: true,
    showFirstAndLastNav: true,
    showPreviousAndNextNav: true,
    sort: 'title',
    orderby: 'asc'
  }

  componentDidMount() {
    this.getAllSpareDetails(1, this.state.sort, this.state.orderby);
    this.menuControl();
  }

  menuControl() {
    let menuControl = this.props.menus;
    var x;
    let partsview = 'none';
    let partsedit = 'none';
    let partsexport = 'none';
    menuControl.map((z) => {
      if (z.type == "submenucontrol") {
        if (z.menu == 'partsview') {
          if (z.edit == true || z.edit == 'true') {
            partsview = 'show';
          }
        }
        if (z.menu == 'partsedit') {
          if (z.edit == true || z.edit == 'true') {
            partsedit = 'show';
          }
        }
        if (z.menu == 'partsexport') {
          if (z.edit == true || z.edit == 'true') {
            partsexport = 'show';
          }
        }
      }
    })
    this.setState({
      partsview: partsview,
      partsedit: partsedit,
      partsexport: partsexport,
    })
  }

  getAllSpareDetails(page, sort, orderby) {
    let fromSerialNumber = (page * 100) - 100;
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    let url = Server() + 'spares/getallsparedetails.php';
    context.setState({
      load: true, message: 'Getting Spares Info!!!', });
    $.ajax({
      type: 'POST',
      data: { 'userId': userId, 'page': page, 'sort': sort, 'orderby': orderby },
      url: Server() + 'spares/getallsparedetails.php',
      success: function(data)
      {
        console.log(data);
        try {
          data = JSON.parse(data);
          let totalPages = 0;
          for (var i = 0; i < data.length; i++) {
            totalPages = data[i].totalPageNumber;
          }
          totalPages = Number(totalPages);
          totalPages = totalPages / 100;
          let roundOff = Math.round( totalPages );
          if (roundOff < totalPages) {
            roundOff++;
          }
          let length = data.length;
          context.setState({
            load: false,
            data: data,
            length: length,
            fromSerialNumber: fromSerialNumber,
            totalPages: roundOff,
            pageNumber: page,
            sort: sort,
            orderby: orderby
          });
        } catch (e) {
            console.log(e);
          context.setState({
            load: false,
          });
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ pageNumber: activePage });
    this.getAllSpareDetails(activePage, this.state.sort, this.state.orderby);
  }

  search(val) {
    let context = this;
    context.setState({
      load: true,
      data: [],
      message: 'Getting Spares Info!!!',
    });
    $.ajax({
      type: 'POST',
      data: { 'search': val },
      url: Server() + 'spares/searchspares.php',
      success: function(data)
      {
        if (data == 0) {
          alert('No data found!!!');
          context.setState({
            data: [],
            load: false
          })
          return;
        }
        try {
          data = JSON.parse(data);
          context.setState({
            load: false,
            data: data,
          });
        } catch (e) {
            console.log(e);
          context.setState({
            load: false,
            data: []
          });
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  render() {
    let { data, load, message, length } = this.state;
    return (
      <div>
        <Loading load={load} message={message} />
        <View data={data} length={length}
          partsexport={this.state.partsexport}
          fromSerialNumber={this.state.fromSerialNumber}
          pageNumber={this.state.pageNumber} partsedit={this.state.partsedit}
          getAllSpareDetails={this.getAllSpareDetails.bind(this)}
          search={this.search.bind(this)}
          menus={this.props.menus}
          datas={this.props.datas}
          menuPermission={this.props.menuPermission}
          partsedit={this.state.partsedit}
          getData={this.props.getData}/>
        <div align="right">
          <Pagination
            activePage={this.state.pageNumber}
            boundaryRange={this.state.boundaryRange}
            onPageChange={this.handlePaginationChange}
            siblingRange={this.state.siblingRange}
            totalPages={this.state.totalPages}
            ellipsisItem={this.state.showEllipsis ? undefined : null}
            prevItem={this.state.showPreviousAndNextNav ? undefined : null}
            nextItem={this.state.showPreviousAndNextNav ? undefined : null}
          />
        </div>
      </div>
    );
  }
}

export default Home;
